import React from 'react'
import PollPlayView from './PollPlayView'
import { Poll } from 'src/api/types/polls'

export type DashboardPollViewsProps = {
  isPollDetailView: boolean
  selectedPollId: number | undefined
  answerFocus?: boolean
  pollLoading?: boolean
  userId?: number
  activePollId?: number
  onPollDeleted: (pollId: number) => void
  onPlayPoll: (poll: Poll) => void
  onPollBack: () => void
  onBackToDetail?: () => void
  pollBackLabel?: string
  onNewPoll: () => void
  topRightLabel?: string
  onOpenHowToPlay: () => void
  sounds: {
    click: () => void
    submit: () => void
    drag: () => void
    celebrate: () => void
  }
}

const DashboardPollViews: React.FC<DashboardPollViewsProps> = ({
  isPollDetailView,
  selectedPollId,
  answerFocus,
  pollLoading,
  userId,
  activePollId,
  onPollDeleted,
  onPlayPoll,
  onPollBack,
  onBackToDetail,
  pollBackLabel,
  onNewPoll,
  topRightLabel,
  onOpenHowToPlay,
  sounds,
}) => {
  return (
    <PollPlayView
      isPollDetailView={isPollDetailView}
      pollId={selectedPollId}
      answerFocus={answerFocus}
      pollLoading={pollLoading}
      userId={userId}
      activePollId={activePollId}
      onPollDeleted={onPollDeleted}
      onPlayPoll={onPlayPoll}
      onPollBack={onPollBack}
      onBackToDetail={onBackToDetail}
      pollBackLabel={pollBackLabel}
      onNewPoll={onNewPoll}
      topRightLabel={topRightLabel}
      onOpenHowToPlay={onOpenHowToPlay}
      sounds={sounds}
    />
  )
}

export default DashboardPollViews
